import { render, staticRenderFns } from "./W3ChannelDetail.vue?vue&type=template&id=3abc607e&scoped=true"
import script from "./W3ChannelDetail.vue?vue&type=script&lang=js"
export * from "./W3ChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./W3ChannelDetail.vue?vue&type=style&index=0&id=3abc607e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abc607e",
  null
  
)

export default component.exports